import { TimeSpan } from '../types/video-feed-types';
import { Word } from '../types/transcript-types';

export const speakingSlotsToTimeSpans = (speakingSlots: Record<string, number>): TimeSpan[] => {
  return Object.entries(speakingSlots).map(([startStr, end]) => ({
    start: Number(startStr),
    end
  }));
};

export const buildSpeakerSlotsFromTranscript = (transcript: Word[]): Record<string, TimeSpan[]> => {
  const speakerSlotsMap: Record<string, TimeSpan[]> = {};
  let slotStart: number | null = null;
  let slotEnd = 0;

  transcript.forEach((word, index) => {
    slotStart = slotStart ?? word.start_time;
    slotEnd = word.end_time ?? slotEnd;

    if (word.speaker_label !== transcript[index + 1]?.speaker_label) {
      const speakerKey = word.speaker_label;
      if (!speakerSlotsMap[speakerKey]) {
        speakerSlotsMap[speakerKey] = [];
      }
      speakerSlotsMap[speakerKey].push({ start: slotStart ?? 0, end: slotEnd });
      slotStart = null;
    }
  });

  return speakerSlotsMap;
};
